// extracted by mini-css-extract-plugin
export default {"vote_card":"styles_vote_card__pBCD4","input_label":"styles_input_label__HiIAs"};